module.exports = __webpack_public_path__ + "img/share-no.8f0c3520.png";